// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"account-find_inputForm_2vHuQ","textLabel":"account-find_textLabel_2ZUZe","formWrap":"account-find_formWrap_1DTHQ"};